var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.componentClass, staticStyle: { gap: "var(--spacing-xl)" } },
    [
      _vm.isReleased()
        ? [
            _vm.hasAccessToIconPack()
              ? [
                  _c(
                    "site-link",
                    {
                      staticClass: "button",
                      staticStyle: {
                        "--button-background": "var(--theme-action-primary)",
                        "--button-hover-background":
                          "var(--theme-action-primary-dk)",
                      },
                      attrs: { to: _vm.$docs("/web/setup/get-started/") },
                      nativeOn: {
                        click: function ($event) {
                          _vm.$posthog.capture(
                            "pack_landing:start_using_pack_link_click",
                            { pack: _vm.iconPack().name }
                          )
                        },
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "margin-right-sm",
                        attrs: {
                          icon: _vm.$v6.solid.faRocketLaunch,
                          size: "lg",
                        },
                      }),
                      _vm._v(
                        "\n        Start Using " +
                          _vm._s(_vm.iconPack().label) +
                          "\n      "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "site-link",
                    {
                      staticClass: "button",
                      staticStyle: {
                        "--button-background": "var(--theme-action-acccent)",
                        "--button-hover-background":
                          "var(--theme-action-acccent-dk)",
                      },
                      attrs: { to: { name: "latest.download" } },
                      nativeOn: {
                        click: function ($event) {
                          _vm.$posthog.capture(
                            "pack_landing:download_pack_link_click",
                            { pack: _vm.iconPack().name }
                          )
                        },
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "margin-right-sm",
                        attrs: {
                          icon: _vm.$v6.solid.faArrowDownToLine,
                          size: "lg",
                        },
                      }),
                      _vm._v(
                        "\n        Download " +
                          _vm._s(_vm.iconPack().label) +
                          "\n      "
                      ),
                    ],
                    1
                  ),
                ]
              : _c(
                  "site-link",
                  {
                    staticClass: "button",
                    staticStyle: {
                      "--button-background": "var(--theme-action-primary)",
                      "--button-hover-background":
                        "var(--theme-action-primary-dk)",
                    },
                    attrs: { to: { name: "plans" } },
                    nativeOn: {
                      click: function ($event) {
                        _vm.$posthog.capture(
                          "pack_landing:get_plan_link_click",
                          { pack: _vm.iconPack().name }
                        )
                      },
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "margin-right-sm",
                      attrs: { icon: _vm.$v6.solid.faRocketLaunch, size: "lg" },
                    }),
                    _vm._v(
                      "\n      Get " +
                        _vm._s(_vm.iconPack().label) +
                        " with Font Awesome " +
                        _vm._s(_vm.requiredPlanLevelForAccess()) +
                        "\n    "
                    ),
                  ],
                  1
                ),
          ]
        : [
            _vm.hasAccessToIconPack()
              ? _c("wa-message", {
                  staticStyle: {
                    "--message-border-color": "var(--theme-title-tag-color)",
                    "--message-with-icon-decorative-color":
                      "var(--theme-title-tag-color)",
                  },
                  attrs: {
                    "icon-name": "faClock",
                    title: `Soon ${
                      _vm.iconPack().label
                    } and the fa-galaxy will be yours!`,
                    content: `Your ${_vm.requiredPlanLevelForAccess()} Plan will include this Icon Pack when it's released!`,
                  },
                })
              : _c(
                  "span",
                  {
                    staticClass: "display-flex flex-items-baseline",
                    staticStyle: { gap: "var(--spacing-md)" },
                  },
                  [
                    _c(
                      "site-link",
                      {
                        staticClass: "button",
                        staticStyle: {
                          "--button-background": "var(--theme-action-primary)",
                          "--button-hover-background":
                            "var(--theme-action-primary-dk)",
                        },
                        attrs: { to: { name: "plans" } },
                        nativeOn: {
                          click: function ($event) {
                            _vm.$posthog.capture(
                              "pack_landing:get_plan_link_click",
                              { pack: _vm.iconPack().name }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "margin-right-sm",
                          attrs: {
                            icon: _vm.$v6.solid.faRocketLaunch,
                            size: "lg",
                          },
                        }),
                        _vm._v(
                          "\n        Get Font Awesome " +
                            _vm._s(_vm.requiredPlanLevelForAccess()) +
                            "\n      "
                        ),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n\n      and get " +
                        _vm._s(_vm.iconPack().label) +
                        " when it's released!\n    "
                    ),
                  ],
                  1
                ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }